import { useFeatureGates } from '@office-start/feature-gates-service';
import { LazyComponentErrorBoundary, } from '@office-start/office-home-app-shared';
import { IMMEDIATE_PRIORITY } from '@office-start/scheduler-service';
import React, { lazy, useMemo } from 'react';
var QuickAccessLazyComponent = lazy(
/* webpackChunkName: "quick-access" */
function () { return import('@office-start/quick-access-component'); });
export var QuickAccess = function () {
    var featureGates = useFeatureGates().data;
    var lazyFeatureProps = useMemo(function () {
        var _a, _b;
        return {
            disabled: !((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.quickAccessV1Gates) === null || _b === void 0 ? void 0 : _b.quickAccessV1Enabled),
            schedulePriority: IMMEDIATE_PRIORITY,
        };
    }, [featureGates]);
    return (React.createElement(LazyComponentErrorBoundary, { componentName: "QuickAccess", lazyFeatureProps: lazyFeatureProps },
        React.createElement(QuickAccessLazyComponent, null)));
};
//# sourceMappingURL=QuickAccess.js.map